import api from './client';

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export interface CostBreakdown {
  infrastructure: number;
  ecoles: number;
  creches: number;
  co: number;
  sport: number;
  culturel: number;
  espaces_publics: number;
}

export interface ProjectSummary {
  id: string;
  name: string;
  logements: number;
  emplois: number;
  ha_total: number | null;
  total_cost: number;
}

export interface DashboardStats {
  total_projects: number;
  total_sessions?: number;
  total_logements: number;
  total_emplois: number;
  total_cost: number;
  total_ha: number;
  avg_density: number;
  cost_breakdown: CostBreakdown;
  sessions_by_status?: Record<string, number>;
  projects_summary: ProjectSummary[];
}

export interface OrgChildStat {
  org_id: string;
  org_name: string;
  org_code: string;
  project_count: number;
  total_logements: number;
  total_emplois: number;
  total_cost: number;
  total_ha: number;
}

export interface OrgInfo {
  id: string;
  name: string;
  code: string;
  level: string;
  parent_id: string | null;
}

export interface OrgStats {
  organization: OrgInfo;
  children_stats: OrgChildStat[];
  projects: ProjectSummary[];
  total_projects: number;
  total_logements: number;
  total_emplois: number;
  total_cost: number;
  total_ha: number;
  avg_density: number;
  cost_breakdown: CostBreakdown;
  sbp_breakdown: Record<string, number>;
}

export interface HierarchyNode {
  id: string;
  name: string;
  code: string;
  level: 'federal' | 'canton' | 'commune';
  parent_id: string | null;
  project_count: number;
  total_logements: number;
  total_emplois: number;
  total_cost: number;
  total_ha: number;
  avg_density: number;
  cost_breakdown: CostBreakdown;
  children: HierarchyNode[];
}

export interface HierarchyResponse {
  roots: HierarchyNode[];
  totals: DashboardStats;
}

// ---------------------------------------------------------------------------
// API calls
// ---------------------------------------------------------------------------

export async function fetchDashboardStats(): Promise<DashboardStats> {
  const res = await api.get<DashboardStats>('/analytics/dashboard');
  return res.data;
}

export async function fetchOrgStats(orgId: string): Promise<OrgStats> {
  const res = await api.get<OrgStats>(`/analytics/organizations/${orgId}/stats`);
  return res.data;
}

export async function fetchHierarchy(): Promise<HierarchyResponse> {
  const res = await api.get<HierarchyResponse>('/analytics/hierarchy');
  return res.data;
}
